import { Text, View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { StatusBar } from 'expo-status-bar'
import { Button } from '@/src/components/ui/Button'
import { colors } from '@/src/theme'

import { PostPaymentStepOneWave } from '../../components/PostPaymentStepOneWave'
import { PostPaymentStepProgress } from '../../components/PostPaymentStepProgress'
import {
  NON_SCALING_TEXT_PROPS,
  STEP_ONE_CONTENT_TOP_MARGIN,
  STEP_ONE_DESCRIPTION_STYLE,
  STEP_ONE_TITLE_STYLE,
} from './constants'
import { usePostPaymentOnboardingContext } from './PostPaymentOnboardingContext'
import { PostPaymentOnboardingScreenHeader } from './PostPaymentOnboardingScreenHeader'

export function PostPaymentOnboardingIntroStep() {
  const {
    state,
    dispatch,
    continueLabel,
    insetsBottom,
    logoutLabel,
    stepOneDescription,
    stepOneTitle,
    postPaymentProgressTotal,
    waveHeight,
    waveWidth,
    handleSignOut,
  } = usePostPaymentOnboardingContext()

  return (
    <SafeAreaView
      className="bg-background-primary"
      style={{ flex: 1, backgroundColor: colors.backgroundPrimary }}
    >
      <StatusBar style="dark" />
      <View
        className="px-6 pt-6 pb-6"
        style={{ flex: 1, paddingHorizontal: 24, paddingTop: 24 }}
      >
        <PostPaymentOnboardingScreenHeader
          isSigningOut={state.isSigningOut}
          onSignOut={handleSignOut}
          logoutLabel={logoutLabel}
        />
        <PostPaymentStepProgress
          step="intro"
          totalSteps={postPaymentProgressTotal}
        />

        <View style={{ flex: 1, justifyContent: 'space-between' }}>
          <View
            className="px-4 items-center"
            style={{ marginTop: STEP_ONE_CONTENT_TOP_MARGIN }}
          >
            <Text
              {...NON_SCALING_TEXT_PROPS}
              className="mb-5"
              style={STEP_ONE_TITLE_STYLE}
            >
              {stepOneTitle}
            </Text>
            <Text
              {...NON_SCALING_TEXT_PROPS}
              style={STEP_ONE_DESCRIPTION_STYLE}
            >
              {stepOneDescription}
            </Text>
          </View>

          <View className="-mx-6" style={{ marginBottom: 24 }}>
            <PostPaymentStepOneWave width={waveWidth} height={waveHeight} />
          </View>
        </View>

        <View style={{ marginBottom: Math.max(insetsBottom, 8) }}>
          <Button
            label={continueLabel}
            onPress={() => dispatch({ type: 'setStep', payload: 'details' })}
            variant="primary"
            size="md"
            containerClassName="w-full"
          />
        </View>
      </View>
    </SafeAreaView>
  )
}
